var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.country && _vm.country !== ""
    ? _c("span", { staticClass: "pr-1" }, [
        _c("img", {
          attrs: {
            height: "11",
            src: _vm.flagUrl,
            title: _vm.displayTitle,
            alt: "",
            "aria-hidden": "true",
            width: "16",
          },
        }),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }